import { defineMessages } from 'react-intl';

const ID_PREFIX = 'WacSignupForm.';
export const messages = defineMessages({
  buttonText: {
    id: `${ID_PREFIX}submitCouponLabel`,
    defaultMessage: 'Agree'
  },
  startButtonText: {
    id: `${ID_PREFIX}submitN2ELabel`,
    defaultMessage: 'Agree and Start now'
  },
  contactSupportForCCPSite: {
    id: `${ID_PREFIX}contactSupportForCCPSite`,
    defaultMessage: 'Contact support'
  },
  ccpSiteMigrationRequiresSupport: {
    id: `${ID_PREFIX}ccpSiteMigrationRequiresSupport`,
    defaultMessage:
      'Migrating to this site requires some additional support from us.'
  },
  ccpStartNewSiteRequiresSupport: {
    id: `${ID_PREFIX}ccpStartNewSiteRequiresSupport`,
    defaultMessage:
      'Creating a new site requires some additional support from us.'
  },
  ccpSiteMigrationFollowSteps: {
    id: `${ID_PREFIX}ccpSiteMigrationfollowSteps`,
    defaultMessage: 'Please follow these steps once you '
  },
  ccpSiteMigrationFollowStepsBelow: {
    id: `${ID_PREFIX}ccpSiteMigrationFollowStepsBelow`,
    defaultMessage: ' below.'
  },
  ccpSiteMigrationStepSelect: {
    id: `${ID_PREFIX}ccpSiteMigrationStepSelect`,
    defaultMessage: '1. Select '
  },
  ccpSiteMigrationStepProductTrials: {
    id: `${ID_PREFIX}ccpSiteMigrationStepProductTrials`,
    defaultMessage: 'Product trials'
  },
  ccpSiteMigrationStepChoose: {
    id: `${ID_PREFIX}ccpSiteMigrationStepChoose`,
    defaultMessage: ', then choose '
  },
  ccpSiteMigrationStepExtendProductTrials: {
    id: `${ID_PREFIX}ccpSiteMigrationStepExtendProductTrials`,
    defaultMessage: 'Extend product trials'
  },
  ccpSiteMigrationStepSelectThe: {
    id: `${ID_PREFIX}ccpSiteMigrationStepSelectThe`,
    defaultMessage: '2. Select the '
  },
  ccpSiteMigrationStepSEN: {
    id: `${ID_PREFIX}ccpSiteMigrationStepSEN`,
    defaultMessage: 'SEN'
  },
  ccpSiteMigrationStepDCLicense: {
    id: `${ID_PREFIX}ccpSiteMigrationStepDCLicense`,
    defaultMessage: ' of the Data Center license, and click '
  },
  ccpSiteMigrationStepHelp: {
    id: `${ID_PREFIX}ccpSiteMigrationStepHelp`,
    defaultMessage: 'Need more help'
  },
  ccpSiteMigrationStepAdditionalInfo: {
    id: `${ID_PREFIX}ccpSiteMigrationStepAdditionalInfo`,
    defaultMessage:
      '3. In the {AdditionalDetailsFieldName} field, provide the cloud URL or entitlement number on which you wish to apply your cloud migration trial.'
  },
  ccpSiteMigrationStepAdditionalDetailsFieldName: {
    id: `${ID_PREFIX}ccpSiteMigrationStepAdditionalDetailsFieldName`,
    defaultMessage: 'Additional Details'
  },
  startButtonTextChooseSignup: {
    id: `${ID_PREFIX}startButtonTextChooseSignup`,
    defaultMessage: 'Continue'
  },
  loginChooseSignup: {
    id: `${ID_PREFIX}loginChooseSignup`,
    defaultMessage:
      "<p>Trying to access Confluence? <a href='https://id.atlassian.com/login'>Log in</a></p>"
  },
  devopsButtonText: {
    id: `${ID_PREFIX}devopsButtonText`,
    defaultMessage: 'Sign up'
  },
  devopsStartButtonText: {
    id: `${ID_PREFIX}devopsStartButtonText`,
    defaultMessage: 'Sign up'
  },
  submitProcessingLabel: {
    id: `${ID_PREFIX}submitProcessingLabel`,
    defaultMessage: 'Starting...'
  },
  defaultWelcomeMessage: {
    id: `${ID_PREFIX}signupFormGreeting`,
    defaultMessage: 'Create your account'
  },
  personalizedWelcomeMessage: {
    id: `${ID_PREFIX}signupFormPersonalizedGreeting`,
    defaultMessage: 'Welcome back, {username}'
  },
  noCard: {
    id: `${ID_PREFIX}signupFormPostContent`,
    defaultMessage: 'NO CREDIT CARD REQUIRED'
  },
  alwaysFreeForUpto: {
    id: `${ID_PREFIX}alwaysFreeForUpto`,
    defaultMessage: 'Always free for up to 10 users.'
  },
  noCreditCardNeeded: {
    id: `${ID_PREFIX}noCreditCardNeeded`,
    defaultMessage: 'No credit card needed.'
  },
  freeAndNoCreditCardNeeded: {
    id: `${ID_PREFIX}freeAndNoCreditCardNeeded`,
    defaultMessage: 'Free for up to 10 users. No credit card needed.'
  },
  eula: {
    id: `${ID_PREFIX}cloudEulaText`,
    defaultMessage:
      "<p>By clicking below, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>"
  },
  eulaCompass: {
    id: `${ID_PREFIX}eulaCompass`,
    defaultMessage:
      "<p>By signing up for this Early Access Program (“EAP”), you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> (“TOS”) and acknowledge the Atlassian <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a></p>"
  },
  eulaCompassTooltip: {
    id: `${ID_PREFIX}eulaCompassTooltip`,
    defaultMessage:
      '<p>The EAP products are considered “Beta Versions”, as set forth in Section 14 of the TOS and are subject to applicable terms, conditions, and disclaimers. Atlassian will use the information you provide on this sign-up form to contact you about the EAP program, including updates to the program, feedback requests, and offers.</p>'
  },
  eulaChooseSignup: {
    id: `${ID_PREFIX}eulaChooseSignup`,
    defaultMessage:
      "<p>By clicking “Continue” below, you agree to the Atlassian Cloud <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Terms of Service</a> and acknowledge the Atlassian <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>"
  },
  marketingConsent: {
    id: `${ID_PREFIX}marketingCommunicationsCheckboxSignupText`,
    defaultMessage: `Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.`
  },
  newSite: {
    id: `${ID_PREFIX}informMessageStartNewSiteSimplified`,
    defaultMessage: 'Start a new site'
  },
  createNewSite: {
    id: `${ID_PREFIX}createNewSite`,
    defaultMessage: 'Create a new site'
  },
  existingSite: {
    id: `${ID_PREFIX}existingSite`,
    defaultMessage: 'Use an existing site'
  },
  differentAcountSignin: {
    id: `${ID_PREFIX}informEmailLoggedInMsg`,
    defaultMessage:
      '<p><a href="{switchAccountUrl}">Sign in with a different Atlassian account</a></p>'
  },
  useDifferentAccountSignin: {
    id: `${ID_PREFIX}useDifferentAccountSignin`,
    defaultMessage:
      '<p><a href="{switchAccountUrl}">Use a different Atlassian account</a></p>'
  },
  developerMode: {
    id: `${ID_PREFIX}informMessageDeveloperWarning`,
    defaultMessage:
      '<h4>You are signing up for a free development instance of Atlassian Cloud.</h4><p>Free development instances are intended to be used for development and testing purposes only and has the usage limits noted below. Atlassian does not offer support for free development instances and reserves the right to delete such instances at any time without notice. Atlassian monitors the usage of such development instances and may cancel any instance being used in an unauthorized or unintended manner.</p><ul><li>Jira Software, Jira Core: 5 users free</li><li>Jira Service Desk: 1 agent free</li><li>Confluence: 5 users free</li></ul>'
  },
  invalidMigrationSource: {
    id: `${ID_PREFIX}invalidMigrationSource`,
    defaultMessage:
      '<h4>Invalid trial activation</h4><p>It looks we weren\'t able to activate your extended trial.</p><p>Check with the site administrator, or login to <a href="https://my.atlassian.com">my.atlassian.com</a> to confirm your activation link is complete and correct, and that you have an eligible server or data center license.</p>'
  },
  claimedMigrationSource: {
    id: `${ID_PREFIX}claimedMigrationSource`,
    defaultMessage:
      '<h4>Your extended trial has already been activated</h4><p>It looks like someone has already activated this trial.</p><p>Log in to <a href="https://my.atlassian.com">my.atlassian.com</a> or contact your site administrator for more information.</p>'
  },
  selectSite: {
    id: `${ID_PREFIX}selectSite`,
    defaultMessage: 'Select a site'
  },
  selectAccount: {
    id: `${ID_PREFIX}selectAccount`,
    defaultMessage: 'Select an account'
  },
  selectOrganization: {
    id: `${ID_PREFIX}selectOrganization`,
    defaultMessage: 'Select your Atlassian organization'
  },
  yourSite: {
    id: `${ID_PREFIX}siteNameN2ELabel`,
    defaultMessage: 'Your site'
  },
  siteNameLabel: {
    id: `${ID_PREFIX}siteNameLabel`,
    defaultMessage: 'Site name'
  },
  siteNameOptional: {
    id: `${ID_PREFIX}siteNameOptional`,
    defaultMessage: 'Site name (optional)'
  },
  siteNameOptionalMessageN2N: {
    id: `${ID_PREFIX}siteNameOptionalMessageN2N`,
    defaultMessage: `Don't worry, you can change this later.`
  },
  siteNameOptionalMessageN2E: {
    id: `${ID_PREFIX}siteNameOptionalMessageN2E`,
    defaultMessage: `Choose an existing site below, or create a new one.`
  },
  siteNameSuite: {
    id: `${ID_PREFIX}siteNameSuiteLabel`,
    defaultMessage: 'Name your suite'
  },
  siteNameSuiteDescription: {
    id: `${ID_PREFIX}siteNameSuiteDescriptionLabel`,
    defaultMessage: '* We’ll use this to name your site and workspaces'
  },
  email: {
    id: `${ID_PREFIX}emailLabel`,
    defaultMessage: 'Work email'
  },
  password: {
    id: `${ID_PREFIX}passwordLabel`,
    defaultMessage: 'Password'
  },
  firstName: {
    id: `${ID_PREFIX}firstNameLabel`,
    defaultMessage: 'First name'
  },
  lastName: {
    id: `${ID_PREFIX}lastNameLabel`,
    defaultMessage: 'Last name'
  },
  fullNameLabel: {
    id: `${ID_PREFIX}fullNameLabel`,
    defaultMessage: 'Full name'
  },
  gdprMessage: {
    id: `${ID_PREFIX}gdprMessage`,
    defaultMessage:
      'Select the data center region to store your Opsgenie specific product data:'
  },
  errorValidationMessage: {
    id: `${ID_PREFIX}errorValidationMessage`,
    defaultMessage: 'Please review the highlighted fields below and try again.'
  },
  errorDomainLengthMinMsg: {
    id: `${ID_PREFIX}errorDomainLengthMinMsg`,
    defaultMessage:
      'Your site name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.'
  },
  errorDomainLengthMinMsgDeferredSiteName: {
    id: `${ID_PREFIX}errorDomainLengthMinMsgDeferredSiteName`,
    defaultMessage:
      'Must be at least three characters (numerals or lowercase letters only). Can’t start or end with a hyphen (-).'
  },
  errorDomainLengthMaxMsg: {
    id: `${ID_PREFIX}errorDomainLengthMaxMsg`,
    defaultMessage:
      "That's a bit too long — try something 50 characters or less."
  },
  errorDomainTakenMsg: {
    id: `${ID_PREFIX}errorDomainTakenMsg`,
    defaultMessage: 'This site is already taken.'
  },
  errorDomainTakenMsgDeferredSiteName: {
    id: `${ID_PREFIX}errorDomainTakenMsgDeferredSiteName`,
    defaultMessage: 'This site name is already taken.'
  },
  errorDomainIsAnnualMsg: {
    id: `${ID_PREFIX}errorDomainIsAnnualMsg`,
    defaultMessage:
      'The Free plan is not yet available for annual subscriptions. Please select a site on a monthly subscription.'
  },
  errorFirstNameMsg: {
    id: `${ID_PREFIX}errorFirstNameMsg`,
    defaultMessage: 'Please enter your first name'
  },
  errorLastNameMsg: {
    id: `${ID_PREFIX}gdprMessage`,
    defaultMessage: 'Please enter your last name'
  },
  errorEmailInvalidMsg: {
    id: `${ID_PREFIX}errorEmailInvalidMsg`,
    defaultMessage: 'Please enter a valid email address'
  },
  errorEmailInUseMsg: {
    id: `${ID_PREFIX}errorEmailInUseMsg`,
    defaultMessage: `Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.`
  },
  errorEmailInUseLoginToContinueMsg: {
    id: `${ID_PREFIX}errorEmailInUseLoginToContinueMsg`,
    defaultMessage: 'log in to continue'
  },
  errorPasswordMinMsg: {
    id: `${ID_PREFIX}errorPasswordMinMsg`,
    defaultMessage: 'Password must be at least 8 characters long'
  },
  errorCaptchaMsg: {
    id: `${ID_PREFIX}errorCaptchaMsg`,
    defaultMessage: 'Error with captcha verification'
  },
  warningTimeoutPending: {
    id: `${ID_PREFIX}warningTimeoutPending`,
    defaultMessage: 'Something went wrong. Wait a few minutes, then try again.'
  },
  warningNetworkError: {
    id: `${ID_PREFIX}warningNetworkError`,
    defaultMessage: 'Something went wrong. Please try again.'
  },
  errorTimeout: {
    id: `${ID_PREFIX}errorTimeout`,
    defaultMessage:
      '<span>It\'s taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <a href="/company/contact">contact us</a>.</span>'
  },
  aaidMismatch: {
    id: `${ID_PREFIX}aaidMismatch`,
    defaultMessage:
      '<span>Something went wrong. Please refresh your page, then try again.</span>'
  },
  helpTooltipText: {
    id: `${ID_PREFIX}helpTooltipText`,
    defaultMessage:
      'Must be at least 3 lowercase characters, numbers and letters only.'
  },
  deferredSiteNameTooltipText: {
    id: `${ID_PREFIX}deferredSiteNameTooltipText`,
    defaultMessage:
      'Your site name is the URL used to find your site, so try something your team will easily recognize.'
  },
  reCaptchaLegal: {
    id: `${ID_PREFIX}reCaptchaLegal`,
    defaultMessage:
      'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.'
  },
  infoBoxModal: {
    id: `${ID_PREFIX}infoBoxModal`,
    defaultMessage:
      'A site is the unique URL where you access your Atlassian products–Confluence, Jira Software, Jira Service Management, or Jira Work Management. <br><br>You access Bitbucket Cloud account on <a href="https://bitbucket.org/">bitbucket.org</a>.'
  },
  infoBoxModalCta: {
    id: `${ID_PREFIX}infoBoxModalCta`,
    defaultMessage: 'Understand site and Bitbucket Cloud account'
  },
  infoBoxDefault: {
    id: `${ID_PREFIX}infoBoxDefault`,
    defaultMessage: ' '
  },
  infoBoxSite: {
    id: `${ID_PREFIX}infoBoxSite`,
    defaultMessage:
      "You already have a site with other Atlassian products in which Jira Software will be added to. We'll create a new Bitbucket Cloud account for you using the same name."
  },
  infoBoxSiteJsw: {
    id: `${ID_PREFIX}infoBoxSiteJsw`,
    defaultMessage:
      'Select an existing site below and we’ll create a new Bitbucket Cloud account for you using the same name.'
  },
  infoBoxBb: {
    id: `${ID_PREFIX}infoBoxBb`,
    defaultMessage:
      "You already have a Bitbucket Cloud account. Create a new site for Jira Software and they'll be automatically integrated."
  },
  infoBoxSiteBb: {
    id: `${ID_PREFIX}infoBoxSiteBb`,
    defaultMessage:
      'You already have a site with other Atlassian products in which Jira Software will be added to. You also have a Bitbucket Cloud account. They will be automatically integrated.'
  },
  jswTrialNotice: {
    id: `${ID_PREFIX}jswTrialNotice`,
    defaultMessage:
      "You'll get a 1-month free trial of Jira Software for this site."
  },
  jsmConfluenceNotice: {
    id: `${ID_PREFIX}jsmConfluenceNotice`,
    defaultMessage:
      'We recommend you add Jira Service Management to an existing Confluence site now since there will be no way to link them afterwards.'
  },
  yourBitbucketAccount: {
    id: `${ID_PREFIX}yourBitbucketAccount`,
    defaultMessage: 'Your Bitbucket Cloud account'
  },
  bitbucketAccountDuplicate: {
    id: `${ID_PREFIX}bitbucketAccountDuplicate`,
    defaultMessage:
      'Check this box if you prefer a new account with the same name as the site below.'
  },
  dropdownWithJiraSoftware: {
    id: `${ID_PREFIX}dropdownWithJiraSoftware`,
    defaultMessage: 'Sites with Jira Software:'
  },
  dropdownWithoutJiraSoftware: {
    id: `${ID_PREFIX}dropdownWithoutJiraSoftware`,
    defaultMessage: 'Sites without Jira Software:'
  },
  dropdownWithRecommended: {
    id: `${ID_PREFIX}dropdownWithRecommended`,
    defaultMessage: 'RECOMMENDED SITES'
  },
  dropdownWithoutRecommended: {
    id: `${ID_PREFIX}dropdownWithoutRecommended`,
    defaultMessage: 'OTHER SITES'
  },
  errorName: {
    id: `${ID_PREFIX}errorName`,
    defaultMessage: 'Invalid name pattern.'
  },
  errorNameLength: {
    id: `${ID_PREFIX}errorNameLength`,
    defaultMessage: 'Full name must not be greater than 255 characters'
  },
  siteAdminManageError: {
    id: `${ID_PREFIX}siteAdminManageError`,
    defaultMessage:
      'You do not have permission to manage this site. For further support, contact the site’s administrator.'
  },
  freeBreachInfoBoxConsiderTrial: {
    id: `${ID_PREFIX}freeBreachInfoBoxConsiderTrial`,
    defaultMessage: 'Consider a Standard trial'
  },
  freeBreachInfoBoxCopy: {
    id: `${ID_PREFIX}freeBreachInfoBoxCopy`,
    defaultMessage:
      "<p>This site is eligible for a 30-day trial of a Standard plan, with full-feature access for 5,000 users or agents.</p><p>A trial lets your team use everything together. If you start a new site, it won't be integrated with your other products.</p>"
  },
  freeBreachInfoBoxStartTrialCta: {
    id: `${ID_PREFIX}freeBreachInfoBoxStartTrialCta`,
    defaultMessage: 'Start a 30-day trial'
  },
  freeBreachLimitExceededError: {
    id: `${ID_PREFIX}freeBreachLimitExceededError`,
    defaultMessage: 'This site has more users than Free allows.'
  },
  devopsCarouselEndTextOne: {
    id: `${ID_PREFIX}devopsCarouselEndTextOne`,
    defaultMessage:
      'Check your inbox for useful information and guides to help you get started.'
  },
  devopsCarouselEndTextTwo: {
    id: `${ID_PREFIX}devopsCarouselEndTextTwo`,
    defaultMessage:
      'Easily switch to other Atlassian Products directly from the navigation bar.'
  },
  devopsCarouselEndTextThree: {
    id: `${ID_PREFIX}devopsCarouselEndTextThree`,
    defaultMessage:
      'Add your teammates to plan, track and release great software together.'
  },
  devopsCarouselButton: {
    id: `${ID_PREFIX}devopsCarouselButton`,
    defaultMessage: 'Go to {product}'
  },
  devopsCarouselEndHeading: {
    id: `${ID_PREFIX}devopsCarouselEndHeading`,
    defaultMessage: "You're all set up!"
  },
  devopsSignedInWelcomeMessage: {
    id: `${ID_PREFIX}devopsSignedInWelcomeMessage`,
    defaultMessage: "Let's set up your DevOps suite"
  },
  siteNameSuiteDescriptionDevops: {
    id: `${ID_PREFIX}siteNameSuiteDescriptionDevops`,
    defaultMessage: '* We’ll use this to name your suite and workspaces'
  },
  errorDomainTakenMsgDevops: {
    id: `${ID_PREFIX}errorDomainTakenMsgDevops`,
    defaultMessage: 'This suite is already taken.'
  },
  errorDomainLengthMinMsgDevops: {
    id: `${ID_PREFIX}errorDomainLengthMinMsgDevops`,
    defaultMessage:
      'Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.'
  },
  eulaDevops: {
    id: `${ID_PREFIX}eulaDevops`,
    defaultMessage:
      "<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>"
  },
  helpTooltipTextDevops: {
    id: `${ID_PREFIX}helpTooltipTextDevops`,
    defaultMessage:
      'Choose a name for the sites and workspaces that will make up your suite. Most teams use their company or organization.'
  },
  opsgenieDataStorageInfoBoxCopy: {
    id: `${ID_PREFIX}opsgenieDataStorageInfoBoxCopy`,
    defaultMessage:
      '<p>Some of your data is automatically stored in the US. <a href="https://www.atlassian.com/software/opsgenie/tos">Learn more</a></p>'
  },
  heading: {
    id: `${ID_PREFIX}signupOfferingIncludesFeaturesSignupFormHeading`,
    defaultMessage: 'Start now'
  },
  subheading: {
    id: `${ID_PREFIX}signupOfferingIncludesFeaturesSignupFormSubheading`,
    defaultMessage: ''
  },
  greeting: {
    id: `${ID_PREFIX}signupFormPersonalizedGreeting`,
    defaultMessage: 'Welcome back, {username}'
  },
  cloudStandard: {
    id: `${ID_PREFIX}cloudStandard`,
    defaultMessage: 'Cloud Standard'
  },
  cloudPremium: {
    id: `${ID_PREFIX}cloudPremium`,
    defaultMessage: 'Cloud Premium'
  },
  cloudFree: {
    id: `${ID_PREFIX}cloudFree`,
    defaultMessage: 'Cloud Free'
  },
  ssoCheck: {
    id: `${ID_PREFIX}errorSsoInUse`,
    defaultMessage:
      'You must use single sign-on to access your account and continue signing up for your product. <a href="{redirectUrl}">Login to continue</a>.'
  },
  localeError: {
    id: `${ID_PREFIX}localeError`,
    defaultMessage: 'We stand with Ukraine'
  },
  localeErrorMessage: {
    id: `${ID_PREFIX}localeErrorMessage`,
    defaultMessage:
      'Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus.'
  },
  localeErrorButton: {
    id: `${ID_PREFIX}localeErrorButton`,
    defaultMessage: 'Learn more'
  },
  beaconRequireProducts: {
    id: `${ID_PREFIX}beaconRequireProducts`,
    defaultMessage:
      'Beacon requires one or more Atlassian products. Since there are no products associated with this account, switch accounts above or explore our Atlassian suite.'
  },
  beaconExplore: {
    id: `${ID_PREFIX}beaconExplore`,
    defaultMessage: 'Explore Atlassian products'
  },
  inputSiteNameMessage: {
    id: `${ID_PREFIX}inputSiteNameMessage`,
    defaultMessage:
      'Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later.'
  },
  siteNameInstructions: {
    id: `${ID_PREFIX}siteNameInstructions`,
    defaultMessage:
      'Must be at least three characters (numbers or lowercase letters only) and can’t start or end with a hyphen (-).'
  },
  siteNameInstructionsExperimentB: {
    id: `${ID_PREFIX}siteNameInstructionsExperimentB`,
    defaultMessage:
      'This site name is just a suggestion. Feel free to change to something your team will recognize.'
  },
  personalizedNameSiteMessage: {
    id: `${ID_PREFIX}personalizedNameSiteMessage`,
    defaultMessage: "Let's name your site, {username}"
  },
  bitbucketWorkspaceIdFieldLabelMessage: {
    id: `${ID_PREFIX}bitbucketWorkspaceIdFieldLabelMessage`,
    defaultMessage: 'Your new workspace'
  },
  bitbucketOrganizationIdFieldLabelMessage: {
    id: `${ID_PREFIX}bitbucketOrganizationIdFieldLabelMessage`,
    defaultMessage: "We'll create your workspace in this organization"
  },
  bitbucketWorkspaceIdFieldHelperMessage: {
    id: `${ID_PREFIX}bitbucketWorkspaceIdFieldHelperMessage`,
    defaultMessage:
      'The workspace ID can only contain lowercase letters, numbers, dashes, and underscores.'
  },
  bitbucketSubmitButtonTextMessage: {
    id: `${ID_PREFIX}bitbucketSubmitButtonTextMessage`,
    defaultMessage: 'Agree and create workspace'
  },
  bitbucketWorkspaceIdFieldErrorMessageCMT: {
    id: `${ID_PREFIX}bitbucketWorkspaceIdFieldErrorMessageCMT`,
    defaultMessage:
      'The workspace ID is invalid. Workspace IDs can only contain lowercase letters, numbers, dashes, and underscores.'
  },
  bitbucketWorkspaceIdTakenErrorMessageCMT: {
    id: `${ID_PREFIX}bitbucketWorkspaceIdTakenErrorMessageCMT`,
    defaultMessage: 'This workspace ID is taken. Try another ID.'
  },
  bitbucketMissingOrgsInfoMessage: {
    id: `${ID_PREFIX}bitbucketMissingOrgsInfoMessage`,
    defaultMessage:
      'If an organization is not listed in the dropdown menu, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.'
  },
  bitbucketCreateNewOrgInfoMessage: {
    id: `${ID_PREFIX}bitbucketCreateNewOrgInfoMessage`,
    defaultMessage:
      'We need to create a new Atlassian organization, because you currently do not have an organization in Atlassian\'s centralized user management. If you have any questions, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.'
  },
  bitbucketOrgCreationPreparingProductMessage: {
    id: `${ID_PREFIX}bitbucketOrgCreationPreparingProductMessage`,
    defaultMessage: "We're preparing your product."
  },
  bitbucketOrgCreationEstimatedTimeMessage: {
    id: `${ID_PREFIX}bitbucketOrgCreationEstimatedTimeMessage`,
    defaultMessage: "This won't take more than a minute or two."
  },
  productActivationFailureMessage: {
    id: `${ID_PREFIX}productActivationFailureMessage`,
    defaultMessage:
      '<p>Something went wrong on our end. Please try again. If this keeps happening, <a href="https://support.atlassian.com/contact/">contact support</a>.</p>'
  }
});

export const getTranslatableError = (
  error: string,
  isDevops?: boolean,
  isDeferredSiteName?: boolean
) => {
  switch (error) {
    case 'Please enter a valid email address':
      return messages.errorEmailInvalidMsg;
    case 'Password must be at least 8 characters':
      return messages.errorPasswordMinMsg;
    case 'Your site name must be at least 3 characters long. Use only lowercase letters and numbers.':
      if (isDevops) {
        return messages.errorDomainLengthMinMsgDevops;
      } else if (isDeferredSiteName) {
        return messages.errorDomainLengthMinMsgDeferredSiteName;
      } else {
        return messages.errorDomainLengthMinMsg;
      }
    case "That's a bit too long — try something 50 characters or less.":
      return messages.errorDomainLengthMaxMsg;
    case 'Invalid name pattern.':
      return messages.errorName;
    case 'Site name is unavailable':
      if (isDevops) {
        return messages.errorDomainTakenMsgDevops;
      } else if (isDeferredSiteName) {
        return messages.errorDomainTakenMsgDeferredSiteName;
      } else {
        return messages.errorDomainTakenMsg;
      }
    case 'An Atlassian account exists for this email address':
      return messages.errorEmailInUseMsg;
    case 'warningTimeoutPending':
      return messages.warningTimeoutPending;
    case 'errorTimeout':
      return messages.errorTimeout;
    case 'accountIdMisMatch':
      return messages.aaidMismatch;
    case 'orgCreateFailure':
    case 'productActivateFailure':
      return messages.productActivationFailureMessage;
    default:
      return { defaultMessage: error, id: `${ID_PREFIX}errorFallThrough` };
  }
};
